import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from '@material-ui/core';


const SuccessAttDeadline = ({ open, handleClose, onClick }) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
    >
      <DialogTitle>
        Prazo de captação atualizado com sucesso!
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          O prazo de captação do seu projeto foi atualizado e ele está regularizado.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SuccessAttDeadline;